module.exports = __webpack_public_path__ + "img/tv-simulation.fdbd2592.webp";